import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
export default {
    install(Vue, options) {
        Vue.prototype.getPdf = function(idStr, title) {
            var targetDom = document.querySelector('#' + idStr);
            var opts = {
                allowTaint: true,
                taintTest: false,
                useCORS: true,
                width: targetDom.clientWidth, // dom 原始宽度
                height: targetDom.clientHeight,
                dpi: window.devicePixelRatio * 1.8,
                scale: 1.8, // 按比例增加分辨率
            };
            html2Canvas(targetDom, opts).then(function(canvas) {
                let contentWidth = canvas.width;
                let contentHeight = canvas.height;
                let pageHeight = (contentWidth / 592.28) * 841.89;
                let leftHeight = contentHeight;
                let position = 0;
                let imgWidth = 595.28;
                let imgHeight = (592.28 / contentWidth) * contentHeight;
                let pageData = canvas.toDataURL('image/jpeg', 1.0);
                let PDF = new JsPDF('', 'pt', 'a4');
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                        leftHeight -= pageHeight;
                        position -= 841.89;
                        if (leftHeight > 0) {
                            PDF.addPage();
                        }
                    }
                }

                PDF.save(title + '.pdf');
            });
        };
    },
};
